import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

type ContainerProps = {
  $shouldShow: boolean;
};

export const Container = styled.div<ContainerProps>`
  position: fixed;
  inset-block-end: 0;
  inset-inline-start: 50%;
  z-index: 999999;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  inline-size: calc(100% - 20px);
  max-inline-size: 343px;
  padding: 16px;

  border-radius: 6px;

  background-color: rgba(39, 48, 62, 0.97);

  opacity: 0;
  transform: translate(-50%, 100%);

  will-change: opacity, transform;

  transition: 300ms all ease-out;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 604px;
  }

  ${props =>
    props.$shouldShow &&
    css`
      opacity: 1;
      transform: translate3d(-50%, -20px, 0);
    `}
`;

export const Text = styled.div`
  max-inline-size: 226px;
  margin-inline-end: 16px;

  color: #ffffff;
  font-size: 12px;
  font-family: Roboto, sans-serif;
  line-height: 16px;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 483px;
    margin-inline-end: 20px;

    font-size: 14px;
    line-height: 18px;
  }

  a {
    color: #ffffff;
    text-decoration: underline;
  }
`;

export const Button = styled.div`
  padding-block: 7px;
  padding-inline: 8px;

  color: #ffffff;
  font-size: 14px;
  font-family: Roboto, sans-serif;
  line-height: 16.4px;

  border: 0;
  border-radius: 2px;

  background-color: #4585ff;

  cursor: pointer;

  touch-action: manipulation;
`;
